<template>
  <div class="cooperation-com-page">
    <jw-card :bordered="false" class="cooperation-card">
      <div class="cooperation-title">
        <span class="cooperation-title-text">{{ $t('协作人') }}</span>
        <div class="cooperation-title-icons">
          <qfei-icon-add-person-outlined class="cooperation-icon" v-if="userInfo?.roles?.indexOf(permissionList[type]) !== -1 && buttons.indexOf(permissionList[type]) > -1 && permission && permission == 1" width="20" height="20" @click="updateModalOpen" />

          <template v-if="userInfo?.roles?.indexOf(groupPermissionList[type]) !== -1 && buttons.indexOf(groupPermissionList[type]) > -1 && permission && permission == 1">
            <template v-if="groupShow">
              <jw-tooltip :content="$t('群组名称') + ':' + groupList.chatName" position="lt">
                <a :href="groupList?.shareLink" target="_blank" class="cooperation-icon-link"> <qfei-icon-comment-outlined class="cooperation-icon" width="20" height="20" /></a>
              </jw-tooltip>
            </template>
            <template v-else>
              <jw-tooltip :content="$t('创建群组')" position="lt">
                <span @click="updateGroup"> <qfei-icon-create-group-outlined class="cooperation-icon" width="20" height="20" /></span>
              </jw-tooltip>
            </template>
          </template>
        </div>
      </div>

      <div class="cooperation-content">
        <!-- <jw-spin v-if="loading" class="spin-loading"> </jw-spin> -->
        <template v-if="loading">
          <fh-skeleton-cooperation />
        </template>
        <template v-else-if="!loading && list.length">
          <div v-for="(item, index) in list" :key="item.collaboratorId" :class="'cooperation-item-' + index">
            <jw-tooltip :content="item.collaboratorType == '1' ? $t('负责人') : $t('协作人')" position="br" mini>
              <xl-avatar v-if="item.collaboratorName" :key="item.collaboratorId" :hasName="false" :avatar="{ id: item.collaboratorId, name: item.collaboratorName, url: item.collaboratorAvatar }" :size="32" />
              <span v-if="item.collaboratorType == '1' && (item.collaboratorName || item.departmentName)" class="star"></span>
            </jw-tooltip>
          </div>
          <div class="img-list" v-if="result.length == 2 || result.length == 3 || result.length >= 4">
            <div class="img-puzzle" v-if="result.length == 2">
              <span class="img-span"><img :src="result[0]?.collaboratorAvatar" class="img-top" /></span>
              <span class="img-span"><img :src="result[1]?.collaboratorAvatar" class="img-top" /></span>
            </div>
            <div class="img-puzzle" v-if="result.length == 3">
              <span class="img-span"><img :src="result[0]?.collaboratorAvatar" class="img-top" /></span>
              <span class="img-span"><img :src="result[1]?.collaboratorAvatar" class="img-bot" /><img class="img-bot" :src="result[2]?.collaboratorAvatar" /></span>
            </div>
            <div class="img-puzzle" v-if="result.length >= 4">
              <span class="img-span"><img :src="result[0]?.collaboratorAvatar" class="img-bot" /><img :src="result[1]?.collaboratorAvatar" class="img-bot" /></span>
              <span class="img-span"><img :src="result[2]?.collaboratorAvatar" class="img-bot" /><img class="img-bot" :src="result[3]?.collaboratorAvatar" /></span>
            </div>
            <div class="mask">
              <span class="total">+{{ total }}</span>
            </div>
          </div>
          <template v-if="((userInfo?.roles?.indexOf(permissionList[type]) !== -1 && buttons.indexOf(permissionList[type]) > -1) || (userInfo?.roles?.indexOf(managePermissionList[type]) !== -1 && buttons.indexOf(managePermissionList[type]) > -1)) && permission && permission == 1">
            <span class="more"> <icon-more :size="22" @click="ManagementModalOpen" style="cursor: pointer" /></span>
          </template>
        </template>
        <template v-else>
          <jw-empty v-if="!loading" class="eltimeline" :img-src="imgSvg"></jw-empty>
        </template>
      </div>
    </jw-card>
    <!-- // 新增编辑 -->
    <update-cooperation ref="updateRef" @cb="getCollaborator"></update-cooperation>
    <!-- // 管理协作人 -->
    <management ref="managementRef" @cb="getCollaborator"></management>
    <!--组建群组  -->
    <add-group ref="addgroupRef" @cb="getCollaborator"></add-group>
  </div>
</template>
<script>
import { reactive, toRefs, ref, inject, onMounted } from 'vue';
import UpdateCooperation from './update-cooperation/update-cooperation.vue';
import AddGroup from './add-group/add-group.vue';
import management from './management/management.vue';
import { useUserStore } from '@/store';
import { clientService, layoutService } from '@/api/';
import useLoading from '@/hooks/loading';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import imgSvg from '@/assets/images/img-no-record.svg';
import fhSkeletonCooperation from '../../fh-detail/components/fh-skeleton-cooperation/fh-skeleton-cooperation.vue';

export default {
  name: 'XlCooperation',
  components: {
    UpdateCooperation,
    management,
    AddGroup,
    fhSkeletonCooperation
  },
  props: {
    moduleId: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { t } = useI18n();
    const { userInfo } = useUserStore(); //用户信息
    const { loading, setLoading } = useLoading(true);
    const data = reactive({
      list: [],
      result: [],
      total: 0,
      pageSize: 10,
      groupShow: false,
      groupList: [], //群组数据
      id: inject('detailParams').id, //客户id,
      type: inject('detailParams').entity,
      permission: inject('detailParams')?.permission, //协作人权限
      permissionList: { 1: 'clue:addCollaborator', 2: 'customer:addCollaborator', 3: 'businessOpportunity:addCollaborator', 6: 'priceSheet:addCollaborator', 8: 'contract:addCollaborator', 10: 'saleOrder:addCollaborator', 12: 'afterSale:addCollaborator', 13: 'returnOrder:addCollaborator' },
      managePermissionList: { 1: 'clue:manageCollaborator', 2: 'customer:manageCollaborator', 3: 'businessOpportunity:manageCollaborator', 6: 'priceSheet:manageCollaborator', 8: 'contract:manageCollaborator', 10: 'saleOrder:manageCollaborator', 12: 'afterSale:manageCollaborator', 13: 'returnOrder:manageCollaborator' },
      groupPermissionList: { 1: 'clue:addGroup', 2: 'customer:addGroup', 3: 'businessOpportunity:addGroup', 6: 'priceSheet:addGroup', 8: 'contract:addGroup', 10: 'saleOrder:addGroup', 12: 'afterSale:addGroup', 13: 'returnOrder:addGroup' }
    });
    // 新增/编辑实例
    const updateRef = ref();
    //管理协作人
    const managementRef = ref();
    //组件群组
    const addgroupRef = ref();
    // 打开弹窗--新增编辑
    const updateModalOpen = () => {
      updateRef.value.open();
    };
    //打开弹窗-组建群组
    const updateGroup = () => {
      if (userInfo.platform != 2) {
        Message.error(t('您不是飞书成员，无法创建飞书群组'));
      } else {
        addgroupRef.value.open();
      }
    };
    //跳转到群组
    const openGroup = () => {
      window.location.href = data.groupList?.shareLink;
    };
    // 管理协作人
    const ManagementModalOpen = () => {
      managementRef.value.open(buttons);
    };
    const getCollaborator = async () => {
      setLoading(true);
      await getGroupInfo(); //获得群组信息
      const params = {
        businessId: data.id,
        type: data.type,
        page: 1,
        pageSize: data.pageSize
      };
      console.log(params);
      data.list = [];
      data.result = [];
      try {
        const res = await clientService.getCollaborator(params);
        console.log(res);
        setLoading(false);
        if (res.error) {
          Message.error(res.error?.msg || t('协作人查询异常'));
          return;
        }
        const records = res.result?.records;
        if (records.length > 5) {
          data.list = records.splice(0, 4);
          data.total = Number(res.result?.total - 4);
          data.result = records;
        } else {
          data.list = records;
        }
        console.log(records);
      } catch (e) {
        // setLoading(false);
        Message.error(e.message || e.statusText || t('协作人查询异常'));
      }
    };
    //获取群组
    const getGroupInfo = async () => {
      // setLoading(true);
      data.groupShow = false;
      const params = {
        id: data.id,
        type: data.type
      };
      try {
        const res = await clientService.getMemberInfo(params);
        // setLoading(false);
        if (res.error) {
          Message.error(res.error?.msg || t('获取失败'));
          data.groupShow = false;
          return;
        }
        console.log(res);
        data.groupList = res?.result;
        if (res.result?.chatId) {
          data.groupShow = true;
        }
      } catch (e) {
        // setLoading(false);
        data.groupShow = false;
      }
    };
    onMounted(() => {
      getCollaborator();
      getDetail();
      if (data.type >= 200) {
        data.permissionList[data.type] = `${data.type}:addCollaborator`;
        data.managePermissionList[data.type] = `${data.type}:manageCollaborator`;
        data.groupPermissionList[data.type] = `${data.type}:addGroup`;
      }
    });
    const buttons = ref([]);
    const getDetail = async () => {
      if (!props?.moduleId) {
        return false;
      }
      try {
        const params = {
          entity: data.type,
          moduleId: props.moduleId,
          businessId: data.id,
          apiIndex: props.moduleId
        };
        const json = await layoutService.getDetail(params);
        if (!json.error) {
          const _buttons = [];
          json?.result?.map((b) => {
            _buttons.push(b.value);
          });
          buttons.value = _buttons;
        }
      } catch (e) {
        console.log(e);
      }
    };
    return {
      updateModalOpen,
      updateGroup,
      openGroup,
      updateRef,
      managementRef,
      addgroupRef,
      UpdateCooperation,
      ManagementModalOpen,
      userInfo,
      loading,
      setLoading,
      imgSvg,
      getCollaborator,
      buttons,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-cooperation.less';
</style>
